import initAsyncRouter from './async-router'
import ButtonLimited from './components/button-limited.vue'
import tableContentBtn from './components/table-content-btn.vue'
import login from './system-page/login/login.vue'
import updatePaswd from './components/update-pswd.vue'

export { ButtonLimited, login, updatePaswd, tableContentBtn }

export default initAsyncRouter
